import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Controller } from '../Controller';
import { OrgSwitcher } from './OrgSwitcher';
import { DrawerMenuDashboardMobile } from './DrawerMenuDashboardMobile';
import { AppHelper } from '../../helpers/AppHelper';

export function MobileMoreMenu(props) {

  const [state, setState] = useState({
    settingPopover: null,
    orgSwitcherDialog: false,
    selectedOrgId: Controller.get().roleHelper().getOrgId()
  })

  useEffect(() => {
  }, [])

  const orgSwitcherDialogOpen = () => {
    setState({ ...state, orgSwitcherDialog: true, settingPopover: null });
  }

  const orgSwitcherDialogClose = () => {
    setState({ ...state, orgSwitcherDialog: false, settingPopover: null });
  }

  const onOrgChange = event => {
    setState({ ...state, [event.target.name]: event.target.value });
  }

  const doActionSave = () => {
    Controller.get().roleHelper().setCurrentOrgInfo(state.selectedOrgId)
    setState({ ...state, orgSwitcherDialog: false })
    const pathname = Controller.get().roleHelper().getHome()
    window.location.href = pathname
  }

  const menuItems = AppHelper.getDrawerMenuItems()[0].length > 4 ? [AppHelper.getDrawerMenuItems()[0].splice(4)] : []

  return (
    <Fragment>
      <DrawerMenuDashboardMobile
        orgSwitcherDialogOpen={orgSwitcherDialogOpen}
        menuItems={menuItems} />
      <OrgSwitcher
        orgSwitcherDialog={state.orgSwitcherDialog}
        orgSwitcherDialogClose={orgSwitcherDialogClose}
        inProcess={state.inProcess}
        selectedOrgId={state.selectedOrgId}
        onOrgChange={onOrgChange}
        doActionSave={doActionSave} />
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/common/components/MobileMoreMenu.js